<template>
  <v-container fluid class="pa-0">
    <!-- // bulk_csv -->
    <v-layout
      v-if="permissions.includes('bulk_csv') && processFlowIndex === 0"
      column
    >
      <v-toolbar class="elevation-1">
        <h4>
          Bulk Import Process by CSV - Staff / Students (Victorian Government
          Schools)
        </h4>
      </v-toolbar>
      <v-flex class="ml-4 mt-4">
        <v-layout column>
          <v-label
            >★ This process helps to improve Students and Staff details in bulk.
            To do that you have to select and attached the existing updated data
            file in following data path.
          </v-label>
          <v-label
            >★ Please click <v-icon color="blue"> attach_file </v-icon> the file
            attached icon in relevant area and browse the file path as follow.
          </v-label>
          <v-label
            >&nbsp;&nbsp;&nbsp;&nbsp;For Students -
            \\XXXXAFS01\eduhub\ST_XXXX.csv (XXXX-four digit school number)
          </v-label>
          <v-label
            >&nbsp;&nbsp;&nbsp;&nbsp;For Staff - \\XXXXAFS01\eduhub\SF_XXXX.csv
            (XXXX-four digit school number)
          </v-label>
          <v-label
            >★ Then click the upload button
            <v-icon color="orange"> cloud_upload </v-icon>
          </v-label>
          <v-label
            >★ Once the data sync, It says "Success, Staff/Students details
            uploaded successfully".
          </v-label>
        </v-layout>
      </v-flex>
      <v-flex sd12>
        <csv-upload></csv-upload>
      </v-flex>
      <div class="ml-4 mt-4 mb-4">
        <v-label
          >★ If you see any error message, please email to
          <a href="mailto: support@edpass.co">support@edpass.co</a>. We will
          help you as soon as possible.
        </v-label>
      </div>
    </v-layout>
    <v-divider></v-divider>
    <header-toolbar
      ref="headerBar"
      :title="bulkProcessTitle"
      :nobuttons="false"
      :processFlowIndex="processFlowIndex"
      @categoryChanged="currentCategory = arguments[0]"
      @bulkChanged="bulkUpdated"
    />
    <v-layout v-if="Object.keys(bulklist).length === 0" pa-4>
      <v-card>
        <v-card-title>
          <h4>Staff</h4>
        </v-card-title>
        <v-layout
          v-if="permissions.includes('staff')"
          class="pl-4 mb-4 mr-4"
          column
        >
          <v-label
            >★ use separate excel documents for
            <v-chip @click="handleStaffUpload()">Staff</v-chip></v-label
          >
          <v-label
            >★ excel workbook should only contain a single sheet for staff (any
            name)</v-label
          >
          <v-label
            >★ Staff Key, First Name and Surname are reqiuired in excel
            sheet</v-label
          >
          <v-label>★ Only excel sheet supports to upload as a bulk</v-label>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- <v-btn flat @click="location.reload()">Reset</v-btn> -->
          <v-spacer></v-spacer>
          <v-icon class="mr-2" color="blue" @click="handleStaffUpload()">
            attach_file
          </v-icon>
        </v-card-actions>
      </v-card>
      <v-card class="ml-5">
        <v-card-title>
          <h4>Student</h4>
        </v-card-title>
        <v-layout
          v-if="permissions.includes('student')"
          class="pl-4 mb-4 mr-4"
          column
        >
          <v-label
            >★ use separate excel documents for<v-chip>{{
              isSecondary ? "Secondary Students" : "Primary Students"
            }}</v-chip></v-label
          >
          <v-label
            >★ excel workbook should only contain a single sheet for student
            (any name)</v-label
          >
          <v-label
            >★ Student ID, First Name, Surname and Class(Home Group) are
            reqiuired in excel sheet</v-label
          >
          <v-label>★ Additional classes will be list down separately</v-label>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-icon class="mr-2" color="blue" @click="handleStudentUpload()">
            attach_file
          </v-icon>
        </v-card-actions>
      </v-card>
    </v-layout>
    <!-- Key mapper to send backend -->
    <v-layout v-if="processFlowIndex === 0">
      <v-card-text class>
        <v-card
          outlined
          :elevation="1"
          v-for="(list, key) in bulklist"
          :key="key"
          style="margin-bottom: 20px"
        >
          <v-card-title class="title">
            {{ list.fileName && (list.fileName.split(".") || [""])[0] }}
            <v-spacer></v-spacer>
            <v-btn
              class="elevation-0"
              color="clear"
              @click="processFlowIndex = 1"
            >
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            dense
            :headers="headersList(list.headers)"
            :items="list.data"
            item-key="SFKEY"
            class="elevation-0"
            no-action
          >
            <template slot="items" slot-scope="props">
              <td v-for="head in list.headers" :key="head">
                {{ props.item[head] || "N/A" }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-layout>
    <!-- ------------------------------------------- -->
    <validate
      v-if="processFlowIndex === 1"
      :bulk="bulklist[0]"
      :activeCategory="currentCategory"
    />
  </v-container>
</template>
<script>
import Validate from "./bulk/Validate";
import CsvUpload from "./bulk/CSVBulkUpload";
import APIBulk from "@/mixins/APIBulk";
import HeaderToolbar from "./bulk/HeaderToolbar";
export default {
  components: {
    Validate,
    CsvUpload,
    HeaderToolbar,
  },
  mixins: [APIBulk],
  data() {
    return {
      format: "text/csv",
      selectedCategory: "",
      processFlowIndex: 0,
      activeUser: {},
      currentCategory: "",
      formData: null,
      bulk: {},
      csvPaths: {
        staff: "",
        student: "",
      },
    };
  },
  computed: {
    bulkProcessTitle: function() {
      let title = "Bulk Import Process - Staff / Students";
      if (!this.user.permissions.includes("staff")) {
        title = "Bulk Import Process - Students";
      }
      if (!this.user.permissions.includes("student")) {
        title = "Bulk Import Process - Staff";
      }
      if (
        !this.user.permissions.includes("student") &&
        !this.user.permissions.includes("staff")
      ) {
        title = "Bulk Import Process";
      }
      if (this.processFlowIndex === 1) {
        title = "Bulk Import Process - Validate";
      }
      return title;
    },
    bulklist: function() {
      let list = [];
      for (let key of Object.keys(this.bulk)) {
        list.push(this.bulk[key]);
      }
      return list;
    },
    isSecondary: function() {
      let activeuser = localStorage.active_user;
      if (!activeuser) {
        return false;
      }

      activeuser = JSON.parse(activeuser);
      if (!activeuser) {
        return false;
      }

      return activeuser.company_sub_type === 2;
    },
  },
  methods: {
    handleStudentUpload: function() {
      if (this.isSecondary == true) {
        this.$refs.headerBar.category = "Secondary Students";
      } else {
        this.$refs.headerBar.category = "Primary Students";
      }
    },
    handleStaffUpload: function() {
      this.$refs.headerBar.category = "Staff";
    },
    bulkUpdated: function(bulk) {
      let self = this;
      if (
        this.currentCategory == "Primary Students" ||
        this.currentCategory == "Secondary Students"
      ) {
        let itemkey = Object.keys(bulk)[0];
        if (!itemkey) {
          this.$toast.error("Invalid bulk selection, Try again.", "Error", {
            position: "topCenter",
          });
        }
        if (bulk[itemkey].headers.includes("SFKEY")) {
          this.$toast.error(
            "Check the selected bulk list is valid to " + self.currentCategory,
            "Error",
            {
              position: "topCenter",
            }
          );
          this.bulk = {};
          return;
        }
      }
      if (this.currentCategory == "Staff") {
        let itemkey = Object.keys(bulk)[0];
        if (!itemkey) {
          this.$toast.error("Invalid bulk selection, Try again.", "Error", {
            position: "topCenter",
          });
        }
        if (bulk[itemkey].headers.includes("STKEY")) {
          this.$toast.error(
            "Check the selected bulk list is valid to " + self.currentCategory,
            "Error",
            {
              position: "topCenter",
            }
          );
          this.bulk = {};
          return;
        }
      }
      this.bulk = bulk;
    },
    headersList: function(obs) {
      return obs.map((ob) => {
        return { text: ob, value: ob, sortable: false };
      });
    },
  },
};
// https://github.com/axios/axios/issues/789
</script>

<style scoped>
label {
  margin-top: 20px;
}
</style>
